import React from "react";
import { ITkViewButtonJudgementProps } from "../../../type/componentsType/TkViewButtonJudgement";
import TkButton from "../../atoms/TkButton";
import { buttonOptions } from "./parts";

/**
 * 判定ボタンを表示するコンポーネントです。
 *
 * @param flowType フロータイプ
 * @param Status ステータス
 * @param onClick クリックイベントハンドラ
 */
const TkViewButtonJudgement: React.FC<ITkViewButtonJudgementProps> = (
  props
) => {
  const {
    flowType,
    Status,
    onClick,
    disabledAll,
    disabledList = [],
    businessType,
  } = props;

  const handleOnClick = (item: string) => () => {
    onClick && onClick(item);
  };

  const renderButton = () => {
    if (!Status) return null;

    let buttonLabel = buttonOptions[Status][flowType];
    switch (businessType) {
      case "JOB-14":
      case "JOB-48":
      case "JOB-51":
      case "JOB-74":
      case "JOB-82":
        buttonLabel = buttonLabel.replace("契約者に差戻し", "担当者に差戻し");
        break;
      case "JOB-68":
        buttonLabel = buttonLabel.replace("契約者に差戻し", "取下げ");
        break;
      case "JOB-70":
      case "JOB-77":
        buttonLabel = buttonLabel.replace("契約者に差戻し,", "");
        break;
    }

    if (buttonLabel) {
      return (
        <>
          {buttonLabel.split(",").map((item) => (
            <TkButton
              key={item}
              mr
              onClick={handleOnClick(item)}
              data-testid={item}
              disabled={disabledAll || disabledList.includes(item)}
            >
              {item}
            </TkButton>
          ))}
        </>
      );
    }
    return null;
  };

  return <>{renderButton()}</>;
};

export default TkViewButtonJudgement;
